import React from 'react';
import PropTypes from 'prop-types';
import Separator from 'styles/basic/Separator';
import path from 'path';
import { Spinner } from 'styles/components/Spinner';
import PageTitle from './Title';
import Button from './Button';
import { Grid, Col } from './Grid';
import { Unflatten } from '../redux/Mapper';
import Paper from 'mrf/view/Paper';
import { useTranslation } from 'react-i18next';
import { setFormValueByContext, useFormDataSelector, useFormSelector } from '../redux/ReduxHelper';
import { FormContext } from './FormCRUD';
import { toURLQuery } from 'mrf/utils/StringGenerators';
import { useDispatch } from 'react-redux';
import { parseErrors } from 'mrf/utils/ValidationUtils';
import If from 'mrf/utils/If';

FormReport.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object,

    context: PropTypes.object,
    descriptor: PropTypes.object,
    title: PropTypes.string.isRequired, // Form title.
    id: PropTypes.any, // Determines if is Edit mode, id of the object being edited.
    map: PropTypes.func, // Mapping function to transform the object before submitting.
    children: PropTypes.any,
    applySpacing: PropTypes.bool,
    hideCancelButton: PropTypes.bool,
};

export default function FormReport({
    children,
    match,
    history,
    title,
    context,
    descriptor,
    map = o => o,
    applySpacing=false,
    hideCancelButton=false
}) {
    const dispatch = useDispatch();

    const { resource } = context;
    const data = useFormDataSelector(context);

    const errorsContext = useFormSelector({
        resource: resource + 'Errors',
        blankForm: () => { },
        blankCondition: () => true,
    });

    const { t } = useTranslation();

    const submit = async action => {
        try {
            const data2 = { ...data };
            delete data2._meta;

            const urlQuery = toURLQuery(map(Unflatten(data2, descriptor)));

            history.push(path.join(match.url, 'search?' + urlQuery));

        } catch (e) {
            e.errors = parseErrors(e);
            setFormValueByContext(dispatch, errorsContext, { ...e, _execute: action === 'execute' });
            throw e;
        }
    }

    const handleSubmit = async e => {
        e.preventDefault();
        try {
            await submit('execute');
        } catch (e) {
            console.error(e);
            alert(t('Check your data for errors.'));
        }
    }

    const handleBack = () => {
        history.goBack();
    }

    if (!data) {
        return <Spinner />;
    }

    return <>
        <FormContext.Provider value={context}>
            <div className={applySpacing ? 'w-full px-64 pt-2' : 'w-full'}>
                <form onSubmit={handleSubmit}>
                    <Paper>
                        <PageTitle>{title}</PageTitle>

                        {children}

                        <Separator />
                        <Grid>
                            <Col size={6} />
                            <Col size={3}>
                                <Button color='primary' type='submit'>Search</Button>
                            </Col>

                            <If condition={!hideCancelButton}>
                                <Col size={3}>
                                    <Button color='secondary' type='button' onClick={handleBack}>Back</Button>
                                </Col>
                            </If>
                        </Grid>
                    </Paper>
                </form>
            </div>
        </FormContext.Provider>
    </>;
}
